<template>
    <div class="add-smoothie container">
        <h2 class="center-align indigo-text">Add New Smoothie Recipe</h2>
        <form @submit.prevent = "addSmoothie">
            <div class="field title">
                <label for="title">Smoothie title</label>
                <input type="text" name="title" v-model="title">
            </div>
            <div class="field" v-for="(ing, index) in ingredients" :key="index">
                <label for="ingredient">Ingredient:</label>
                <input type="text" name="ingredient" v-model="ingredients[index]">
                <i class="material-icons delete" @click="deleteIng(ing)">delete</i>
            </div>
            <div class="field ingredients">
                <label for="add-ingredient">Add an ingredient</label>
                <input type="text" name="add-ingredient" @keydown.enter.prevent="addIng" v-model="another">
            </div>
            <div class="field center-align">
                <p class="red-text" v-if="feedback">{{ feedback }}</p>
                <button class="waves-effect pink waves-light btn">Add Smoothie</button>
            </div>
        </form>    
    </div>
</template>

<script>
    import db from '@/firebase/init'
    import slugify from 'slugify'
    export default {

        name: 'AddSmoothie',
        data() {
            return {
                title: null,
                another: null,
                ingredients: [],
                feedback: null,
                slug: null
            }
        },
        methods: {

            addSmoothie() {

                if(this.title) {

                    this.feedback = null

                    this.slug = slugify(this.title, {
                        replacement: '-',
                        remove: /[@()#$%^&*-+~]/g,
                        lower: true

                    })

                    db.collection('smoothies').add({

                        title: this.title,
                        ingredients: this.ingredients,
                        slug: this.slug

                    }).then(() => {
                        this.$router.push({ name: 'Index' })
                    }).catch(error => {
                        console.log(error)
                    })

                } else {

                    this.feedback = "You must enter a smoothie title"

                }

            },

            addIng() {

                if(this.another) {
                    this.ingredients.push(this.another)
                    this.another = null
                    this.feedback = null
                } else {
                    this.feedback= "You must enter a value to add an ingredient"
                }

            },

            deleteIng(ing) {

                this.ingredients = this.ingredients.filter(ingredient => {
                    return ingredient != ing
                })

            }

        }

    }
</script>

<style>

    .add-smoothie {

        margin-top: 1%;
        padding: 2%;
        max-width: 50vw;

    }

    .add-smoothie input:focus-within {

        border-color: indigo !important;

    }

    .add-smoothie h2 {

        font-size: 2em;
        margin: 5% auto;

    }

    .add-smoothie .field {

        margin: 5% auto;
        position: relative;

    }
    
    .add-smoothie .delete {

        cursor: pointer;
        position: absolute;
        right: 0;
        bottom: 20%;
        color: #aaa;
        font-size: 1.4em;


    }

    @media screen and (max-width: 768px) {

      .add-smoothie {

            margin-top: 3%;
            padding: 2%;
            max-width: 100vw;

        }

    }
 
</style>



// WEBPACK FOOTER //
// src/components/AddSmoothie.vue